import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { EventsService } from '../../../events.service';
import { GlobalService } from '../../../../global.service';

@Component({
  selector: 'app-spring-home',
  templateUrl: './spring-home.component.html',
  styleUrls: ['./spring-home.component.css']
})
export class SpringHomeComponent implements OnInit {


  language: any;
  langChosen: string = 'en';

  games: Array<any> = ['pubg-lite', 'crossfire', 'rainbow-six-siege', 'pubg', ];

  mobileView: boolean = false;


  constructor(private router: Router, private activeRoute: ActivatedRoute, public eventService: EventsService, public globalService: GlobalService) {
    if (globalService.isBrwoser) {
      if (window.screen.width < 768) {
        this.mobileView = true;
      }
    }
  }

  ngOnInit() {

    if (this.globalService.isBrwoser) {
      if (localStorage.getItem('language')) {
        this.language = require('./../dictionary/' + localStorage.getItem('language') + '.json');
        this.langChosen = localStorage.getItem('language');
      } else {
        this.language = require('./../dictionary/en.json');
      }
    }


    this.eventService.insomniaGame = this.router.url.split('/')[2];

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.eventService.insomniaGame = event.url.split('/')[2];
      }
    });

  }

  languageChange(value) {
    if (this.globalService.isBrwoser) {
      this.langChosen = value;
      this.language = require('./../dictionary/' + value + '.json');
      this.globalService.language = value;
      localStorage.setItem('language', value);
    }
  }


}
